import AppShell from "@/components/AppShell";
import ChatConversation from "@/components/ChatConversation";

export default function Chat() {
  return (
    <AppShell active="chat">
      <div className="mb-6">
        <h1 className="text-4xl sm:text-5xl font-headline font-light text-primary tracking-tight">Chat</h1>
        <p className="mt-3 text-on-surface-variant">Ask anything — your assistant knows when to bring in your coach.</p>
      </div>
      <div className="bg-surface-container-lowest rounded-3xl p-5 sm:p-6 shadow-ambient h-[68vh]">
        <ChatConversation />
      </div>
    </AppShell>
  );
}
